var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getItemBounds, getItemBoxInterpolation, } from 'app/core/markers/bounds';
import { getTextFormat } from 'app/core/markers/models';
import { getTextCloudPath } from 'app/utils/text';
import { castedProps } from './types';
const TextRender = (props) => {
    var _a;
    const _b = castedProps(props), { marker } = _b, opts = __rest(_b, ["marker"]);
    const { useStroke = true } = opts;
    const id = `text-${marker.id}`;
    const idRef = `#${id}`;
    const format = getTextFormat(marker);
    const { lines } = marker;
    const color = (_a = opts.color) !== null && _a !== void 0 ? _a : marker.color;
    const minAllowedStroke = 8;
    const strokeWidth = format.fontSize * 0.5;
    return (React.createElement("g", { transform: `translate(${marker.x}, ${marker.y})` },
        React.createElement("defs", null,
            React.createElement("text", { id: id, fontFamily: format.fontFamily, fontSize: `${format.fontSize}${format.metrics}` }, lines.map((line, index) => {
                const key = `${marker.id}_${index}`;
                const textY = line.y - line.ascent;
                return (React.createElement("tspan", { key: key, x: line.x, y: textY, lengthAdjust: "spacingAndGlyphs", strokeLinecap: "round", strokeLinejoin: "round", textLength: line.width }, line.text));
            }))),
        React.createElement("g", null,
            useStroke && (React.createElement("use", { href: idRef, fill: "none", stroke: "white", strokeWidth: Math.round(Math.max(strokeWidth, minAllowedStroke)).toFixed(0), strokeOpacity: "0.95", filter: "url(#text-field-shadow)" })),
            React.createElement("use", { href: idRef, stroke: "none", fill: color }))));
};
const TextCloudRender = (props) => {
    const marker = props.marker;
    const bounds = getItemBounds(marker);
    let { data: pathData } = marker.background;
    if (!pathData) {
        pathData = getTextCloudPath(marker);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { transform: `translate(${bounds.x}, ${bounds.y})`, d: pathData, fill: marker.color, fillOpacity: 0.6, stroke: marker.color }),
        React.createElement(TextRender, { marker: marker, useStroke: false, color: "#FFFFFF" })));
};
const DebugTextRuns = (props) => {
    const { marker } = props;
    const boxes = getItemBoxInterpolation(marker);
    return (React.createElement(React.Fragment, null, boxes.map(box => (React.createElement("rect", Object.assign({ key: box.toString() }, box
        .inflate(0.05 * box.width, 0.05 * box.height)
        .toObject(), { stroke: "red", fillOpacity: 0.05, strokeOpacity: 0.3 }))))));
};
const BackgroundRendererMap = {
    cloud: TextCloudRender,
};
export const TextMarkerRenderer = (props) => {
    var _a, _b;
    const marker = props.marker;
    const { lines } = marker;
    if (!lines.length) {
        return null;
    }
    const backgroundType = (_a = marker.background) === null || _a === void 0 ? void 0 : _a.type;
    const Renderer = (_b = BackgroundRendererMap[backgroundType]) !== null && _b !== void 0 ? _b : TextRender;
    return (React.createElement("g", null, Renderer && React.createElement(Renderer, Object.assign({}, props))));
};
